import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import {
  createDeliveryValidationFrom,
  createRunsheetValidationForm,
} from "../../utils/validationSchemas";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextInput";
import Modal from "../Reusable/Modal";
import DriverForm from "./DriverForm";

import { useEffect, useState } from "react";

const CreateDelivery = (props: any) => {
  const {
    handleCreate,
    isLoading,
    defaultBranch,
    handleAddVehicle,
    isVehicleLoading,
    handleAddDriver,
    isDriverLoading,
  } = props;
  const [openAddDriverPopup, setOpenAddDriverPopup] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createDeliveryValidationFrom),
  });

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Submit"}
        isLoading={isLoading}
      >
        <div className={tw`mx-4`}>
          <div className={tw`grid grid-cols-2 gap-x-4 `}>
            <div className={tw`w-full flex  `}>
              <div className={tw`w-full`}>
                <ComboboxInput
                  url={APIS.DRIVER}
                  queryKey={"driver"}
                  register={register("driver")}
                  errors={errors?.driver}
                  name={"driver"}
                  label={"Driver/Rider"}
                  setValue={setValue}
                  placeholder={"Search driver"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
              </div>
              <button
                className={tw`border px-4  py-2 h-10 relative top-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                type="button"
                onClick={() => setOpenAddDriverPopup(!openAddDriverPopup)}
              >
                +
              </button>
            </div>

            <div>
              <TextField
                label={"Note"}
                register={register(`note`)}
                errors={errors?.note}
              />
            </div>
          </div>
        </div>
      </FormLayout>
      <Modal
        isOpen={openAddDriverPopup}
        setIsOpen={setOpenAddDriverPopup}
        title={"Add Driver"}
        children={
          <>
            <DriverForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              handleAddDriver={handleAddDriver}
              isDriverLoading={isDriverLoading}
            />
          </>
        }
      />
    </>
  );
};

export default CreateDelivery;
